import React from 'react';

export const Divider = () => <div className="priority-editor__toolbar-divider" />;
